import { ATTRIBUTION_COOKIE_KEY, type IAttribution } from '@repo/analytics';

export function readAttributionFromCookie(): IAttribution | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${ATTRIBUTION_COOKIE_KEY}=`));
  if (!match) {
    return null;
  }
  try {
    return JSON.parse(decodeURIComponent(match.split('=')[1] ?? '')) as IAttribution;
  } catch {
    return null;
  }
}
